<template>
  <router-view></router-view>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState(['errorGlobal']),
  },
  watch: {
    errorGlobal(mensaje) {
      if (!mensaje) return;
      this.$bvToast.toast(mensaje, {
        title: 'Error de conexión',
        variant: 'danger',
        solid: true,
        toaster: 'b-toaster-top-center',
        autoHideDelay: 6000,
        noCloseButton: true,
      });
      this.SET_ERROR_GLOBAL(null);
    },
  },
  methods: {
    ...mapMutations(['SET_ERROR_GLOBAL']),
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Proxima Nova";
  src: url("assets/font/proximanova-light.woff2");
}
</style>

<style>
@import url("assets/extension_bootstrap.scss");

.title {
  font-size: 20px;
  font-weight: 400 !important;
  font-family: Proxima Nova, -apple-system, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
}

@media (min-width: 768px) {
  .title {
    font-size: 26px;
    font-family: Proxima Nova, -apple-system, Helvetica Neue, Helvetica, Roboto, Arial, sans-serif;
  }
}

.text-gray {
  color: #666;
}

body {
  background: #ebebeb;
}
</style>
